import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { TimePicker } from '@mui/x-date-pickers'
import { TextField } from '@mui/material';
const RHFTime = ({ name, label, ...other }) => {
    const { control } = useFormContext();
    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <TimePicker
                    {...field}
                    label={label}
                    {...other}
                    slots={{ textField: TextField }}
                />
            )}
        />
    )
}

export default RHFTime